import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withTheme, Grid } from '@material-ui/core';
import { FHEContainerForm, FHEItemText, FHEDivider } from 'data/components';
import renderEnvComponent from 'data/common/renderEnvComponent';

class SDM23SMP extends PureComponent {
    static propTypes = {
        theme: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        planningMode: PropTypes.string,
        moduleType: PropTypes.string,
        code: PropTypes.string,
        lineType: PropTypes.string,
        planningSynched: PropTypes.number,
        value: PropTypes.string,
        label: PropTypes.string,
        planningType: PropTypes.string,
        favorite: PropTypes.number,
        calibrated: PropTypes.string
    };

    static defaultProps = {
        planningMode: null,
        moduleType: null,
        code: null,
        lineType: null,
        planningSynched: null,
        value: null,
        label: null,
        planningType: null,
        favorite: null,
        calibrated: null
    };

    render() {
        const {
            planningMode,
            moduleType,
            code,
            lineType,
            planningSynched,
            value,
            label,
            planningType,
            favorite,
            calibrated,
            theme,
            history
        } = this.props;
        return (
            <FHEContainerForm>
                <FHEDivider color={theme.palette.colors.grey100} />
                <Grid container spacing={3}>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.label')} itemContent={label} />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.moduleType')}
                            itemContent={Translator.translate(`general.productModules.${moduleType}`)}
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.lineType')}
                            itemContent={Translator.translate(`general.productModules.${lineType}`)}
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.calibrated')}
                            itemContent={Translator.translate(`general.productModules.${calibrated}`)}
                        />
                    </Grid>
                </Grid>
                <FHEDivider color={theme.palette.colors.grey100} />
                <Grid container spacing={3}>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.planningMode')}
                            itemContent={Translator.translate(`general.productModules.${planningMode}`)}
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.planningSynched')}
                            itemContent={Translator.translate(`general.productModules.${planningSynched}`)}
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.planningType')}
                            itemContent={Translator.translate(`general.productModules.${planningType}`)}
                        />
                    </Grid>
                </Grid>
                <FHEDivider color={theme.palette.colors.grey100} />
                <Grid container spacing={3}>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.code')} itemContent={code} />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.value')} itemContent={value} />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.favorite')}
                            itemContent={Translator.translate(`general.productModules.${favorite}`)}
                        />
                    </Grid>
                </Grid>
            </FHEContainerForm>
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const productKey = props.productKey;
    let productModule;
    if (state.environments[history.environment].data.Products.getIn(['list', productKey, 'productModules'])) {
        productModule = state.environments[history.environment].data.Products.getIn(['list', productKey, 'productModules'], new Map()).first();
    }
    if (productModule === undefined) {
        productModule = new Map();
    }
    return {
        planningMode: productModule.get('planningMode'),
        moduleType: productModule.get('moduleType'),
        code: productModule.get('code'),
        lineType: productModule.get('lineType'),
        planningSynched: productModule.get('planningSynched'),
        value: productModule.get('value'),
        label: productModule.get('label'),
        planningType: productModule.get('planningType'),
        favorite: productModule.get('favorite'),
        calibrated: productModule.get('calibrated')
    };
}

export default withRouter(renderEnvComponent('scenes/Products/components/Product/Fhe/SDM23SMP/index', connect(mapStateToProps)(withTheme(SDM23SMP))));



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Products/components/Product/Fhe/SDM23SMP/index.js